module.exports = __webpack_public_path__ + "img/icon-expand.68408b0a.svg";